export default __webpack_public_path__ + "static/media/b_slide1.b454b637.jpg";